import { isMobile } from "@modules/util/device.ts"
import { registerGlobalEventListener } from "@modules/util/events.ts"
import { getQueryParameter, setQueryParameter } from "../../util/query-parameter"
import { afterFilterApiFetched } from "../after-filter-api-fetched"
import { fetchApiWithAllFilters } from "../api"
import { resetPagination } from "../pagination/pagination"
import { updateActiveFilterBarInDom } from "./filter-bar"

export const distanceSelectElement = () => document.querySelector<HTMLDivElement>(".umkreiswahl")
const distanceSelectValueElement = () => document.querySelector<HTMLDivElement>("#actual-umkreis")
const distanceSelectDropdownElement = () => document.querySelector<HTMLDivElement>(".umkreiswahl .dropdown-toggle")
const distanceSearchTextElement = () => document.querySelector<HTMLDivElement>(".suchtext-umkreis")

export function distanceSelectEnable() {
    distanceSelectElement()?.classList.remove("disabled")
    distanceSelectDropdownElement()?.classList.remove("disabled")
}

export function distanceSelectDisable() {
    distanceSelectElement()?.classList.add("disabled")
    distanceSelectDropdownElement()?.classList.add("disabled")
}

function distanceSelectAddEventListener() {
    const distanceElements = distanceSelectElement()?.querySelectorAll<HTMLLIElement>(".dropdown-menu li a")
    if (distanceElements) {
        for (const element of Array.from(distanceElements)) {
            element.addEventListener("click", async (event: MouseEvent) => {
                if (event.target instanceof HTMLElement) {
                    const value = event.target.closest("a")?.getAttribute("data-umkreis") as string
                    if (value) {
                        resetPagination()

                        setQueryParameter("umkreis", value)
                        updateDistanceSelectInDom()
                        updateActiveFilterBarInDom()
                        afterFilterApiFetched(await fetchApiWithAllFilters())
                    }
                }
            })
        }
    }
}

function distanceSelectCloseDropdown() {
    distanceSelectElement()?.querySelector(".umkreiswahl-inner")?.classList.remove("open")
}

export function updateDistanceSelectInDom() {
    const value = Number.parseInt(getQueryParameter("umkreis") || "20")

    if (value < 0) {
        makeDistanceSelectNotAvailable()
        return
    }

    const distanceSearchTextEl = distanceSearchTextElement()
    const distanceValueTextEl = distanceSelectValueElement()

    if (distanceValueTextEl && distanceSearchTextEl) {
        if (value === 0) {
            distanceSearchTextEl.innerHTML = ""
            distanceValueTextEl.innerHTML = "<strong>ohne</strong>"
        } else {
            distanceSearchTextEl.innerHTML = ` +${value} km`
            distanceValueTextEl.innerHTML = `<strong>${value} km</strong>`
        }
    }

    distanceSelectCloseDropdown()
    disableSmallerDistances(value)
}

function makeDistanceSelectNotAvailable() {
    distanceSelectDisable()
    const distanceSearchTextEl = distanceSearchTextElement()
    const distanceValueTextEl = distanceSelectValueElement()
    if (distanceSearchTextEl) distanceSearchTextEl.innerHTML = ""
    if (distanceValueTextEl) distanceValueTextEl.innerHTML = "<strong>n/a</strong>"
}

export function getSelectedDistance() {
    return getQueryParameter("umkreis") || ""
}

if (SearchConfig.distanceSearched === -1) {
    makeDistanceSelectNotAvailable()
} else {
    const url = new URL(window.location.href)
    const urlParts = url.pathname.split("/")
    // For now dont set umkreis in url when standort search is selected. This would lead to a bug which would respond only with the last (300km) distance search
    if (urlParts[1] !== "standort") {
        distanceSelectEnable()
        setQueryParameter("umkreis", SearchConfig.distanceSearched.toString())
    }
    disableSmallerDistances(SearchConfig.distanceSearched)
}

export function disableSmallerDistances(current: number) {
    if (isMobile()) {
        return
    }
    if (current >= 300) {
        distanceSelectDisable()
        return
    }
    const a = distanceSelectElement()?.querySelectorAll("a") || []
    for (let i = 0; i < a.length; i++) {
        const distance = a[i].getAttribute("data-umkreis")
        if (distance) {
            const value = Number.parseInt(distance)
            if (value <= current) {
                a[i].parentElement?.classList.add("disable-distance-option")
            }
        }
    }
}
distanceSelectAddEventListener()

registerGlobalEventListener("azm.filter-api.after-fetch", (event) => {
    if (event.detail.distanceSearched === "-1") {
        return
    }
    setQueryParameter("umkreis", event.detail.distanceSearched)
    updateDistanceSelectInDom()
})
